import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Container, Paper, Typography } from '@mui/material';

// The building blocks of the "play against the computer" and "play with
// friends" pages, in the same look as the guides.

export const Hero = ({ title, subtitle }) => (
    <Box sx={{ backgroundColor: '#0B2A21', color: '#fff', py: 6, textAlign: 'center' }}>
        <Container maxWidth="md">
            <Typography variant="h3" component="h1" sx={{ fontWeight: 700, mb: 2 }}>{title}</Typography>
            <Typography variant="h6" sx={{ color: 'rgba(255,255,255,0.7)', mb: 3 }}>{subtitle}</Typography>
            <PlayButton />
        </Container>
    </Box>
);

export const Section = ({ title, children }) => (
    <Paper sx={{ p: 4, mb: 4 }}>
        <Typography variant="h4" component="h2" sx={{ fontWeight: 600, mb: 2, color: '#16201C' }}>{title}</Typography>
        {children}
    </Paper>
);

export const Para = ({ children, last }) => (
    <Typography variant="body1" sx={{ color: '#3E4A45', lineHeight: 1.8, mb: last ? 0 : 2 }}>{children}</Typography>
);

/** A numbered list of steps or a list of points, in body text. */
export const Steps = ({ items, ordered }) => (
    <Box component={ordered ? 'ol' : 'ul'} sx={{ color: '#3E4A45', lineHeight: 1.8, pl: 3, mt: 0, mb: 2, '& li': { mb: 1 } }}>
        {items.map((item, i) => <li key={i}>{item}</li>)}
    </Box>
);

export const Question = ({ q, children }) => (
    <Box sx={{ mb: 2.5, '&:last-child': { mb: 0 } }}>
        <Typography variant="h6" component="h3" sx={{ fontWeight: 600, color: '#16201C', mb: 0.5 }}>{q}</Typography>
        <Typography variant="body1" sx={{ color: '#3E4A45', lineHeight: 1.8 }}>{children}</Typography>
    </Box>
);

export const PlayButton = ({ label = 'Play Sequence Now' }) => (
    <Button component={Link} to="/" variant="contained" size="large" sx={{ backgroundColor: '#E2B65B', color: '#16201C', px: 4, '&:hover': { backgroundColor: '#CDA049' } }}>
        {label}
    </Button>
);

export const Cta = ({ title, text }) => (
    <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: '#16201C' }}>{title}</Typography>
        <Typography variant="body1" sx={{ color: '#666', mb: 3 }}>{text}</Typography>
        <PlayButton />
    </Box>
);

export const linkStyle = { color: '#1E6B4F' };
